import Vue from 'vue'
import axios from 'axios'
import env from './env'
import store from './store/index.js'

const api = axios.create({
  baseURL: env.apiUrl
})

api.interceptors.request.use(
  function(config) {
    const accessToken = store.state.auth.token.access_token
    const verificationToken = store.state.auth.verificationToken.token

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    if (verificationToken) {
      config.headers['Verification-Token'] = verificationToken
    }

    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    if (typeof error.response === 'undefined') {
      alert(
        'A network error occurred. This could be a CORS issue or a dropped internet connection.'
      )
    }

    return Promise.reject(error)
  }
)

Vue.prototype.$api = api

export default api
